module.exports = __webpack_public_path__ + "img/story040.d100e2c5.webp";